export const GEOSERVER_API = 'https://geoserver.eagleview.com/geoserver/wms?SERVICE=WMS&REQUEST=GetMap&WIDTH=256&HEIGHT=256&LAYERS=ParcelData&TRANSPARENT=TRUE&FORMAT=image/png';

// Zoom that shows a full zip-code area so users can pan/zoom to find a structure
// when street-level geocoding fails (e.g. legal land descriptions).
export const ZIP_CODE_MAP_ZOOM = 12;
export const STRUCTURE_MAP_ZOOM = 17;
export const ADDRESS_VERIFICATION_STRUCTURE_ZOOM = 20;

export const MAP_DEFAULTS = {
  credentials: process.env.REACT_APP_BING_MAP_CREDENTIALS,
  enableSearchLogo: false,
  center: { latitude: '37.0902', longitude: '-95.7129' },
  zoom: 5,
  minZoom: 1,
  maxZoom: 20,
  minParcelLayerZoom: 16,
  pushpinLimit: 40,
  enableClickableLogo: false,
  customizeOverlays: true,
  isReadOnly: false,
  parcelLayer: 'geoserver',
  disableStreetside: true,
  showRotateButtons: true,
  showLocateMeButton: false,
  disableBirdseye: true,
};

Object.freeze(MAP_DEFAULTS);
Object.freeze(MAP_DEFAULTS.center);

export const EVENTS = {
  CLICK: 'click',
  MOUSEENTER: 'mouseenter',
  MOUSELEAVE: 'mouseleave',
  MOUSEDOWN: 'mousedown',
  MOUSEMOVE: 'mousemove',
  MOUSEUP: 'mouseup',
  TOUCHSTART: 'touchstart',
  TOUCHMOVE: 'touchmove',
  TOUCHEND: 'touchend',
};
